export default [
    {
        path: '/fulfillment/list',
        name: 'fulfillment-list',
        component: () => import('@/views/pages/fulfillment/fulfillment-list/FulfillmentList.vue'),
        meta: {},
        breadcrumb: [
          {
              text: 'Fulfillment',
              active: true,
          },
        ]
    },
    {
        path: '/fulfillment/import/detail/:ref',
        name: 'fulfillment-import-detail',
        component: () => import('@/views/pages/fulfillment/fulfillment-import-trackingno-detail/FulfillmentImportTrackingNoDetail.vue'),
        meta: {},
        breadcrumb: [
          {
              text: 'Fulfillment/Import/TrackingNo',
              active: true,
          },
        ]
    },
    {
        path: '/fulfillment/import/list',
        name: 'fulfillment-import-list',
        component: () => import('@/views/pages/fulfillment/fulfillment-import-trackingno-list/FulfillmentImportTrackingNoList.vue'),
        meta: {},
        breadcrumb: [
          {
              text: 'Fulfillment/Import/TrackingNo/List',
              active: true,
          },
        ]
    },
]